import React from "react";
import classes from "./cardDescription.module.css";

const CardDescription = ({ cardDescription }) => {
  return <p className={classes.cardDescription}>{cardDescription}</p>;
};

export default CardDescription;
